import * as i0 from '@angular/core';
import { Pipe, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, distinctUntilChanged } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import * as i2 from '@niceltd/cxone-components/overflow-tooltip';
import { OverflowTooltipModule } from '@niceltd/cxone-components/overflow-tooltip';
import * as i1 from '@angular/platform-browser';
function OmnibarComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipContent", ctx_r0.itemHeaderText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.itemHeaderText);
  }
}
function OmnibarComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.itemIcon, i0.ɵɵsanitizeHtml);
  }
}
function OmnibarComponent_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r6.itemCountLabel);
  }
}
function OmnibarComponent_div_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
  }
}
function OmnibarComponent_div_5_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r8.selectedItemCountLabel);
  }
}
function OmnibarComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, OmnibarComponent_div_5_div_1_Template, 2, 1, "div", 15)(2, OmnibarComponent_div_5_div_2_Template, 1, 0, "div", 16)(3, OmnibarComponent_div_5_div_3_Template, 2, 1, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.itemCountLabel !== undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.selectedItemCountLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.selectedItemCountLabel);
  }
}
const _c0 = a0 => ({
  "hidden": a0
});
function OmnibarComponent_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵlistener("keydown.enter", function OmnibarComponent_div_6_div_3_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r11 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r11.clearSearchField());
    })("click", function OmnibarComponent_div_6_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r13 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r13.clearSearchField());
    });
    i0.ɵɵpipe(1, "safe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 3, ctx_r9.icon.close), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(5, _c0, !ctx_r9.searchQuery || ctx_r9.searchQuery.length === 0));
    i0.ɵɵattribute("aria-label", "clear search");
  }
}
function OmnibarComponent_div_6_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
    i0.ɵɵpipe(1, "safe");
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 2, ctx_r10.icon.search), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", "search");
  }
}
function OmnibarComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "input", 22);
    i0.ɵɵlistener("focus", function OmnibarComponent_div_6_Template_input_focus_1_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.focusEvent($event));
    })("input", function OmnibarComponent_div_6_Template_input_input_1_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.inputEvent($event));
    })("blur", function OmnibarComponent_div_6_Template_input_blur_1_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.blurEvent($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 23);
    i0.ɵɵtemplate(3, OmnibarComponent_div_6_div_3_Template, 2, 7, "div", 24)(4, OmnibarComponent_div_6_div_4_Template, 2, 4, "div", 25);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r3.searchFormControl)("placeholder", ctx_r3.searchPlaceholderText);
    i0.ɵɵattribute("aria-label", ctx_r3.searchPlaceholderText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.searchQuery && ctx_r3.searchQuery.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.searchQuery === undefined || ctx_r3.searchQuery.length === 0);
  }
}
function OmnibarComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 29);
    i0.ɵɵlistener("click", function OmnibarComponent_div_7_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.toggleFiltersSection());
    })("keydown.enter", function OmnibarComponent_div_7_Template_div_keydown_enter_1_listener() {
      i0.ɵɵrestoreView(_r19);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.toggleFiltersSection());
    });
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(2, 1, ctx_r4.icon.filter), i0.ɵɵsanitizeHtml);
  }
}
function OmnibarComponent_section_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 30)(1, "div", 31);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd()();
  }
}
const _c1 = [[["cxone-omnibar-custom-content"]], [["cxone-omnibar-filters"]]];
const _c2 = (a0, a1) => ({
  "day": a0,
  "night": a1
});
const _c3 = ["cxone-omnibar-custom-content", "cxone-omnibar-filters"];
const _c4 = ["*"];
class OmnibarService {
  constructor() {
    this.icons = {
      // tslint:disable-next-line: max-line-length
      'icon-close': '<svg viewBox="0 0 32 32" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"><path d="M18.24 16l7.52-7.52c.64-.64.64-1.6 0-2.24s-1.6-.64-2.24 0L16 13.76 8.48 6.08c-.64-.64-1.6-.64-2.24 0s-.64 1.6 0 2.24L13.76 16l-7.52 7.52c-.64.64-.64 1.6 0 2.24s1.6.64 2.24 0L16 18.24l7.52 7.52c.64.64 1.6.64 2.24 0s.64-1.6 0-2.24L18.24 16z"/></svg>',
      // tslint:disable-next-line: max-line-length
      'icon-search': '<svg viewBox="0 0 32 32" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"><path d="M0 12.8c0 7.04 5.76 12.8 12.8 12.8 2.88 0 5.6-.96 7.84-2.72l8.64 8.64c.64.64 1.6.64 2.24 0s.64-1.6 0-2.24l-8.64-8.64a12.61 12.61 0 002.72-7.84C25.6 5.76 19.84 0 12.8 0S0 5.76 0 12.8zm3.2 0c0-5.28 4.32-9.6 9.6-9.6s9.6 4.32 9.6 9.6-4.32 9.6-9.6 9.6-9.6-4.32-9.6-9.6z"/></svg>',
      // tslint:disable-next-line: max-line-length
      'icon-filter': '<svg viewBox="0 0 32 32" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"><path d="M26.88 3.2l-9.28 11.68v11.040l-3.2 1.76v-12.8l-0.64-0.8-8.64-10.88h21.76zM30.72 0h-29.44c-0.48 0-0.96 0.32-1.12 0.8-0.32 0.48-0.16 1.12 0.16 1.44l10.88 13.76v14.4c0 0.48 0.48 1.12 0.96 1.44 0.16 0.16 0.48 0.16 0.64 0.16s0.32 0 0.64-0.16l6.4-3.36c0.48-0.16 1.12-0.64 1.12-1.28v-11.2l10.88-13.76c0.32-0.48 0.32-0.96 0.16-1.44-0.32-0.48-0.8-0.8-1.28-0.8v0z"/></svg>'
    };
  }
  getIcon(iconString) {
    return this.icons[iconString];
  }
}
class SafePipe {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
  }
  transform(value) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SafePipe_Factory(t) {
      return new (t || SafePipe)(i0.ɵɵdirectiveInject(i1.DomSanitizer, 16));
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "safe",
      type: SafePipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafePipe, [{
    type: Pipe,
    args: [{
      name: 'safe'
    }]
  }], () => [{
    type: i1.DomSanitizer
  }], null);
})();
class OmnibarComponent {
  /* The search query */
  set searchQuery(v) {
    if (v !== undefined && v !== null) {
      this.searchFormControl.patchValue(v);
    }
  }
  get searchQuery() {
    return this.searchFormControl.value;
  }
  constructor() {
    this.unsubscribe$ = new Subject();
    this.onBlurEventWasCallWithValue = null;
    this.searchFormControl = new UntypedFormControl('');
    /* DebounceTime prop for search value emit event */
    this.searchDebounceTime = 300;
    /* Determines if the complete header section f the omnibar is to be content projected or not */
    this.customOmnibar = false;
    /* Determines whether to show the filter button or not */
    this.isFilterable = true;
    /* Determines whether dark mode/ edit mode is on or off for the omnibar */
    this.nightMode = false;
    /* Determines whether to show a seacr input field or not */
    this.searchable = true;
    /* Determines wehther the omnibar footer is to be shown or not */
    this.showFooter = false;
    /* A callback to indicate that the search query has changed in the text field */
    this.searchQueryChange = new EventEmitter();
    /* A callback to indicate that the search icon has been clicked */
    this.searchButtonClicked = new EventEmitter();
    /* A callback to indicate that the search icon has been clicked */
    this.showFooterChanged = new EventEmitter();
    this.omnibarService = new OmnibarService();
    this.icon = {
      close: this.omnibarService.getIcon('icon-close'),
      search: this.omnibarService.getIcon('icon-search'),
      filter: this.omnibarService.getIcon('icon-filter')
    };
    this.searchFormControl.valueChanges.pipe(takeUntil(this.unsubscribe$), debounceTime(this.searchDebounceTime), distinctUntilChanged()).subscribe(v => {
      this.searchQueryChange.emit(v);
    });
  }
  clearSearchField() {
    this.searchFormControl.patchValue('');
  }
  onSearchBtnClick() {
    this.searchButtonClicked.emit(this.searchQuery);
  }
  toggleFiltersSection() {
    this.showFooter = !this.showFooter;
    this.showFooterChanged.emit(this.showFooter);
  }
  inputEvent(event) {
    if (this.onBlurEventWasCallWithValue) {
      this.searchFormControl.patchValue(this.onBlurEventWasCallWithValue);
    } else {
      const value = event.target.value;
      this.searchFormControl.patchValue(value);
    }
    this.onBlurEventWasCallWithValue = null;
  }
  blurEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    const value = event.target.value;
    this.onBlurEventWasCallWithValue = value;
  }
  focusEvent(event) {
    event.stopPropagation();
    this.onBlurEventWasCallWithValue = null;
  }
  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
  /** @nocollapse */
  static {
    this.ɵfac = function OmnibarComponent_Factory(t) {
      return new (t || OmnibarComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OmnibarComponent,
      selectors: [["cxone-omnibar"]],
      inputs: {
        searchDebounceTime: "searchDebounceTime",
        customOmnibar: "customOmnibar",
        isFilterable: "isFilterable",
        itemCountLabel: "itemCountLabel",
        itemHeaderText: "itemHeaderText",
        itemIcon: "itemIcon",
        nightMode: "nightMode",
        searchable: "searchable",
        searchQuery: "searchQuery",
        searchPlaceholderText: "searchPlaceholderText",
        selectedItemCountLabel: "selectedItemCountLabel",
        showFooter: "showFooter"
      },
      outputs: {
        searchQueryChange: "searchQueryChange",
        searchButtonClicked: "searchButtonClicked",
        showFooterChanged: "showFooterChanged"
      },
      ngContentSelectors: _c3,
      decls: 11,
      vars: 10,
      consts: [[1, "cxone-omnibar", 3, "ngClass"], [1, "content-wrapper", "flex-container", "column"], [1, "header-wrapper", "flex-container"], ["class", "title-wrapper ", 4, "ngIf"], ["class", "icon-wrapper", 4, "ngIf"], ["class", "count-wrapper flex-container", 4, "ngIf"], ["class", "search-wrapper flex-container", 4, "ngIf"], ["class", "filter-wrapper  margin-x-small", 4, "ngIf"], [1, "custom-content-wrapper", "margin-x-small"], ["class", "footer-wrapper flex-container", 4, "ngIf"], [1, "title-wrapper"], ["cxoneOverflowTooltip", "", "placement", "top", 1, "title", 3, "tooltipContent"], [1, "icon-wrapper"], [1, "icon-btn", 3, "innerHTML"], [1, "count-wrapper", "flex-container"], ["class", "count", "aria-live", "assertive", 4, "ngIf"], ["class", "vertical-line", 4, "ngIf"], ["class", "selected-count", 4, "ngIf"], ["aria-live", "assertive", 1, "count"], [1, "vertical-line"], [1, "selected-count"], [1, "search-wrapper", "flex-container"], ["type", "text", "tabindex", "0", 3, "formControl", "placeholder", "focus", "input", "blur"], [1, "button-wrapper"], ["tabindex", "0", "class", "search-icons clear-btn", "role", "button", 3, "innerHTML", "ngClass", "keydown.enter", "click", 4, "ngIf"], ["class", "search-icons search-btn", "role", "button", 3, "innerHTML", 4, "ngIf"], ["tabindex", "0", "role", "button", 1, "search-icons", "clear-btn", 3, "innerHTML", "ngClass", "keydown.enter", "click"], ["role", "button", 1, "search-icons", "search-btn", 3, "innerHTML"], [1, "filter-wrapper", "margin-x-small"], ["tabindex", "0", 1, "filter-btn", 3, "innerHTML", "click", "keydown.enter"], [1, "footer-wrapper", "flex-container"], [1, "dropdown-wrapper"]],
      template: function OmnibarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c1);
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "section", 2);
          i0.ɵɵtemplate(3, OmnibarComponent_div_3_Template, 3, 2, "div", 3)(4, OmnibarComponent_div_4_Template, 2, 1, "div", 4)(5, OmnibarComponent_div_5_Template, 4, 3, "div", 5)(6, OmnibarComponent_div_6_Template, 5, 5, "div", 6)(7, OmnibarComponent_div_7_Template, 3, 3, "div", 7);
          i0.ɵɵelementStart(8, "div", 8);
          i0.ɵɵprojection(9);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(10, OmnibarComponent_section_10_Template, 3, 0, "section", 9);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c2, ctx.nightMode === false, ctx.nightMode === true));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.itemHeaderText && !ctx.customOmnibar);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.itemIcon && !ctx.customOmnibar);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.customOmnibar);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.searchable && !ctx.customOmnibar);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isFilterable && !ctx.customOmnibar);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.isFilterable && ctx.showFooter);
        }
      },
      dependencies: [i1$1.NgClass, i1$1.NgIf, i2.OverflowTooltipDirective, i3.DefaultValueAccessor, i3.NgControlStatus, i3.FormControlDirective, SafePipe],
      styles: [".cxone-omnibar[_ngcontent-%COMP%]   .margin-x-small[_ngcontent-%COMP%]{margin:0 7.5px}.cxone-omnibar[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%]{visibility:0}.cxone-omnibar[_ngcontent-%COMP%]   .flex-container[_ngcontent-%COMP%]{display:flex;align-items:center}.cxone-omnibar[_ngcontent-%COMP%]   .flex-container.column[_ngcontent-%COMP%]{flex-direction:column}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{width:100%;font-size:13px;box-shadow:0 2px 6px #1f324d33}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]{height:60px;width:100%;padding:0 20px;box-sizing:border-box}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .title-wrapper[_ngcontent-%COMP%]{margin-right:10px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .title-wrapper[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#303436;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .icon-wrapper[_ngcontent-%COMP%]{padding:10px 5px 10px 10px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .icon-wrapper[_ngcontent-%COMP%]   .icon-btn[_ngcontent-%COMP%]{width:18px;height:18px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .vertical-line[_ngcontent-%COMP%]{width:1px;height:20px;margin:0 15px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .count-wrapper[_ngcontent-%COMP%]{margin-right:50px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]{margin-right:0}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{width:300px;height:35px;padding:9px 31px 9px 10px;border:0}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus{outline:black solid 2px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]::placeholder{font-size:13px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]{margin-left:-32px;height:30px;padding:7px 6px;width:30px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-icons[_ngcontent-%COMP%]{display:inline-block;height:18px;width:18px;place-items:center center}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .clear-btn[_ngcontent-%COMP%]{cursor:pointer;float:left;place-items:center center}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-btn[_ngcontent-%COMP%]{place-items:center center;float:right}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-btn[_ngcontent-%COMP%]{width:35px;height:35px;padding:10px;cursor:pointer;box-sizing:border-box;border-radius:2px}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .custom-content-wrapper[_ngcontent-%COMP%]{display:flex;position:relative;flex:1}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .footer-wrapper[_ngcontent-%COMP%]{width:100%;padding:12px 20px;align-items:flex-end}.cxone-omnibar[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .footer-wrapper[_ngcontent-%COMP%]   .dropdown-wrapper[_ngcontent-%COMP%]{flex:1}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{color:#333}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]{background-color:#f2f7fa;border-bottom:1px solid rgb(208,210,211)}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .vertical-line[_ngcontent-%COMP%]{background-color:#2e2e2e}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .icon-wrapper[_ngcontent-%COMP%]   .icon-btn[_ngcontent-%COMP%]{fill:#8fa1b3}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background-color:#fff}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]::placeholder{color:#536f80}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]{background-color:#fff}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-icons[_ngcontent-%COMP%]{fill:#526b7a;opacity:.8}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-icons[_ngcontent-%COMP%]:hover{fill:#2d78c2}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-icons[_ngcontent-%COMP%]:active{fill:#237bc2}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-btn[_ngcontent-%COMP%]{margin-left:9px;background-color:#fff;box-shadow:0 1px 2px #1f324d33;fill:#526b7a;opacity:.8}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-btn[_ngcontent-%COMP%]:hover{fill:#176dab}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-btn[_ngcontent-%COMP%]:active{fill:#237bc2}.cxone-omnibar.day[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .footer-wrapper[_ngcontent-%COMP%]{background-color:#f7fafc}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{color:#fff}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]{background-color:#214868}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .vertical-line[_ngcontent-%COMP%]{background-color:#fff}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .icon-wrapper[_ngcontent-%COMP%]   .icon-btn[_ngcontent-%COMP%]{fill:#fff}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{background-color:#627e94}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]::placeholder{color:#fff}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-icons[_ngcontent-%COMP%]{fill:#fff}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-icons[_ngcontent-%COMP%]:hover{fill:#2d78c2}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .search-wrapper[_ngcontent-%COMP%]   .button-wrapper[_ngcontent-%COMP%]   .search-icons[_ngcontent-%COMP%]:active{fill:#237bc2}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-btn[_ngcontent-%COMP%]{border:1px solid #B0CDDB;fill:#fff}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-btn[_ngcontent-%COMP%]:hover{fill:#2d78c2}.cxone-omnibar.night[_ngcontent-%COMP%]   .content-wrapper[_ngcontent-%COMP%]   .header-wrapper[_ngcontent-%COMP%]   .filter-wrapper[_ngcontent-%COMP%]   .filter-btn[_ngcontent-%COMP%]:active{fill:#237bc2}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-omnibar',
      template: "<div class=\"cxone-omnibar\" [ngClass]=\"{ 'day': nightMode === false, 'night': nightMode === true }\">\n    <div class=\"content-wrapper flex-container column\">\n        <section class=\"header-wrapper flex-container\">\n            <div class=\"title-wrapper \" *ngIf=\"itemHeaderText && !customOmnibar\">\n                <div class=\"title\" cxoneOverflowTooltip [tooltipContent]=\"itemHeaderText\"\n                     placement=\"top\">{{ itemHeaderText }}</div>\n            </div>\n            <div class=\"icon-wrapper\" *ngIf=\"itemIcon && !customOmnibar\">\n                <div class=\"icon-btn\" [innerHTML]=\"itemIcon\"></div>\n            </div>\n            <div class=\"count-wrapper flex-container\" *ngIf=\"!customOmnibar\">\n                <div class=\"count\" *ngIf=\"itemCountLabel !== undefined\" aria-live=\"assertive\">{{ itemCountLabel }}</div>\n                <div class=\"vertical-line\" *ngIf=\"selectedItemCountLabel\"></div>\n                <div class=\"selected-count\" *ngIf=\"selectedItemCountLabel\">{{ selectedItemCountLabel }}</div>\n            </div>\n\n\n            <div class=\"search-wrapper flex-container\" *ngIf=\"searchable && !customOmnibar\">\n                <input type=\"text\" [formControl]='searchFormControl' [placeholder]=\"searchPlaceholderText\" tabindex=\"0\"  [attr.aria-label]=\"searchPlaceholderText\" (focus)='focusEvent($event)' (input)=\"inputEvent($event)\" (blur)='blurEvent($event)'>\n                <div class=\"button-wrapper\">\n                    <div *ngIf=\"searchQuery && searchQuery.length > 0\" (keydown.enter)=\"clearSearchField()\" tabindex=\"0\" class=\"search-icons clear-btn\" [innerHTML]=\"icon.close | safe\" (click)=\"clearSearchField()\" role=\"button\" [attr.aria-label]=\"'clear search'\" [ngClass]=\"{ 'hidden': !searchQuery || searchQuery.length === 0}\"></div>\n                    <div *ngIf=\"searchQuery === undefined || searchQuery.length === 0 \" class=\"search-icons search-btn\" [innerHTML]=\"icon.search | safe\" role=\"button\" [attr.aria-label]=\"'search'\" ></div>\n                </div>\n            </div>\n\n            <div class=\"filter-wrapper  margin-x-small\" *ngIf=\"isFilterable && !customOmnibar\" >\n                <div (click)=\"toggleFiltersSection()\" tabindex=\"0\" (keydown.enter)=\"toggleFiltersSection()\" class=\"filter-btn\" [innerHTML]=\"icon.filter | safe\"></div>\n            </div>\n            <div class=\"custom-content-wrapper  margin-x-small\">\n                <ng-content select=\"cxone-omnibar-custom-content\"></ng-content>\n            </div>\n        </section>\n        <section class=\"footer-wrapper flex-container\" *ngIf=\"isFilterable && showFooter\">\n            <div class=\"dropdown-wrapper\">\n                <ng-content select=\"cxone-omnibar-filters\"></ng-content>\n            </div>\n        </section>\n    </div>\n</div>\n",
      styles: [".cxone-omnibar .margin-x-small{margin:0 7.5px}.cxone-omnibar .hidden{visibility:0}.cxone-omnibar .flex-container{display:flex;align-items:center}.cxone-omnibar .flex-container.column{flex-direction:column}.cxone-omnibar .content-wrapper{width:100%;font-size:13px;box-shadow:0 2px 6px #1f324d33}.cxone-omnibar .content-wrapper .header-wrapper{height:60px;width:100%;padding:0 20px;box-sizing:border-box}.cxone-omnibar .content-wrapper .header-wrapper .title-wrapper{margin-right:10px}.cxone-omnibar .content-wrapper .header-wrapper .title-wrapper .title{color:#303436;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-omnibar .content-wrapper .header-wrapper .icon-wrapper{padding:10px 5px 10px 10px}.cxone-omnibar .content-wrapper .header-wrapper .icon-wrapper .icon-btn{width:18px;height:18px}.cxone-omnibar .content-wrapper .header-wrapper .vertical-line{width:1px;height:20px;margin:0 15px}.cxone-omnibar .content-wrapper .header-wrapper .count-wrapper{margin-right:50px}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper{margin-right:0}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper input[type=text]{width:300px;height:35px;padding:9px 31px 9px 10px;border:0}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper input[type=text]:focus{outline:black solid 2px}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper input[type=text]::placeholder{font-size:13px}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper .button-wrapper{margin-left:-32px;height:30px;padding:7px 6px;width:30px}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-icons{display:inline-block;height:18px;width:18px;place-items:center center}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper .button-wrapper .clear-btn{cursor:pointer;float:left;place-items:center center}.cxone-omnibar .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-btn{place-items:center center;float:right}.cxone-omnibar .content-wrapper .header-wrapper .filter-wrapper .filter-btn{width:35px;height:35px;padding:10px;cursor:pointer;box-sizing:border-box;border-radius:2px}.cxone-omnibar .content-wrapper .header-wrapper .custom-content-wrapper{display:flex;position:relative;flex:1}.cxone-omnibar .content-wrapper .footer-wrapper{width:100%;padding:12px 20px;align-items:flex-end}.cxone-omnibar .content-wrapper .footer-wrapper .dropdown-wrapper{flex:1}.cxone-omnibar.day .content-wrapper{color:#333}.cxone-omnibar.day .content-wrapper .header-wrapper{background-color:#f2f7fa;border-bottom:1px solid rgb(208,210,211)}.cxone-omnibar.day .content-wrapper .header-wrapper .vertical-line{background-color:#2e2e2e}.cxone-omnibar.day .content-wrapper .header-wrapper .icon-wrapper .icon-btn{fill:#8fa1b3}.cxone-omnibar.day .content-wrapper .header-wrapper .search-wrapper input[type=text]{background-color:#fff}.cxone-omnibar.day .content-wrapper .header-wrapper .search-wrapper input[type=text]::placeholder{color:#536f80}.cxone-omnibar.day .content-wrapper .header-wrapper .search-wrapper .button-wrapper{background-color:#fff}.cxone-omnibar.day .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-icons{fill:#526b7a;opacity:.8}.cxone-omnibar.day .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-icons:hover{fill:#2d78c2}.cxone-omnibar.day .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-icons:active{fill:#237bc2}.cxone-omnibar.day .content-wrapper .header-wrapper .filter-wrapper .filter-btn{margin-left:9px;background-color:#fff;box-shadow:0 1px 2px #1f324d33;fill:#526b7a;opacity:.8}.cxone-omnibar.day .content-wrapper .header-wrapper .filter-wrapper .filter-btn:hover{fill:#176dab}.cxone-omnibar.day .content-wrapper .header-wrapper .filter-wrapper .filter-btn:active{fill:#237bc2}.cxone-omnibar.day .content-wrapper .footer-wrapper{background-color:#f7fafc}.cxone-omnibar.night .content-wrapper{color:#fff}.cxone-omnibar.night .content-wrapper .header-wrapper{background-color:#214868}.cxone-omnibar.night .content-wrapper .header-wrapper .vertical-line{background-color:#fff}.cxone-omnibar.night .content-wrapper .header-wrapper .icon-wrapper .icon-btn{fill:#fff}.cxone-omnibar.night .content-wrapper .header-wrapper .search-wrapper input[type=text]{background-color:#627e94}.cxone-omnibar.night .content-wrapper .header-wrapper .search-wrapper input[type=text]::placeholder{color:#fff}.cxone-omnibar.night .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-icons{fill:#fff}.cxone-omnibar.night .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-icons:hover{fill:#2d78c2}.cxone-omnibar.night .content-wrapper .header-wrapper .search-wrapper .button-wrapper .search-icons:active{fill:#237bc2}.cxone-omnibar.night .content-wrapper .header-wrapper .filter-wrapper .filter-btn{border:1px solid #B0CDDB;fill:#fff}.cxone-omnibar.night .content-wrapper .header-wrapper .filter-wrapper .filter-btn:hover{fill:#2d78c2}.cxone-omnibar.night .content-wrapper .header-wrapper .filter-wrapper .filter-btn:active{fill:#237bc2}\n"]
    }]
  }], () => [], {
    searchDebounceTime: [{
      type: Input
    }],
    customOmnibar: [{
      type: Input
    }],
    isFilterable: [{
      type: Input
    }],
    itemCountLabel: [{
      type: Input
    }],
    itemHeaderText: [{
      type: Input
    }],
    itemIcon: [{
      type: Input
    }],
    nightMode: [{
      type: Input
    }],
    searchable: [{
      type: Input
    }],
    searchQuery: [{
      type: Input
    }],
    searchPlaceholderText: [{
      type: Input
    }],
    selectedItemCountLabel: [{
      type: Input
    }],
    showFooter: [{
      type: Input
    }],
    searchQueryChange: [{
      type: Output
    }],
    searchButtonClicked: [{
      type: Output
    }],
    showFooterChanged: [{
      type: Output
    }]
  });
})();
class OmnibarFiltersComponent {
  /** @nocollapse */static {
    this.ɵfac = function OmnibarFiltersComponent_Factory(t) {
      return new (t || OmnibarFiltersComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OmnibarFiltersComponent,
      selectors: [["cxone-omnibar-filters"]],
      ngContentSelectors: _c4,
      decls: 1,
      vars: 0,
      template: function OmnibarFiltersComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarFiltersComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-omnibar-filters',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class OmnibarCustomContentComponent {
  /** @nocollapse */static {
    this.ɵfac = function OmnibarCustomContentComponent_Factory(t) {
      return new (t || OmnibarCustomContentComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OmnibarCustomContentComponent,
      selectors: [["cxone-omnibar-custom-content"]],
      ngContentSelectors: _c4,
      decls: 1,
      vars: 0,
      template: function OmnibarCustomContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarCustomContentComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-omnibar-custom-content',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class OmnibarModule {
  /** @nocollapse */static {
    this.ɵfac = function OmnibarModule_Factory(t) {
      return new (t || OmnibarModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OmnibarModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, OverflowTooltipModule, ReactiveFormsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarModule, [{
    type: NgModule,
    args: [{
      declarations: [OmnibarComponent, OmnibarFiltersComponent, OmnibarCustomContentComponent, SafePipe],
      imports: [CommonModule, OverflowTooltipModule, ReactiveFormsModule],
      exports: [OmnibarComponent, OmnibarCustomContentComponent, OmnibarFiltersComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OmnibarComponent, OmnibarCustomContentComponent, OmnibarFiltersComponent, OmnibarModule, OmnibarService, SafePipe };
